import { Box, Grid } from "@mui/material";
import Item from "components/features/Sections/Item/index";
import PlanDetailsContent from "components/features/planDetails/PlanDetailsContent";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";
import { planTypes } from "utils/Types";

import Dialog from "components/common/Dialog";
import PlanType from "components/common/PlanType";
import Typography from "components/common/Typography";
import ActionCardDialogsContext from "components/features/ActionCard/Context";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { resetPlanDetails } from "../PlanAssignment.slice";

export default function PlanDetailDialog() {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const { isOpenPlanDetailDialog, setIsOpenPlanDetaiLDialog } = useContext(ActionCardDialogsContext);

  const { isAbovePropertyUser }: any = useAppSelector((state) => state.app.loggedInUserDetails);
  const selectedPlanDetail = useAppSelector((state) => state.PlanAssignment.planSelection.planDetails);

  useEffect(() => {
    return () => {
      resetPlanDetails();
    };
  });

  return (
    <div>
      <Dialog
        Open={isOpenPlanDetailDialog}
        handleCloseDialog={() => {
          dispatch(resetPlanDetails());
          setIsOpenPlanDetaiLDialog(false);
        }}
        sx={{
          dialog: { maxWidth: "md" },
          dialogPaper: { backgroundColor: colors.Neutral.Neutral100 },
          closeBox: { margin: "24px 24px 24px auto" },
          dialogContent: { margin: "0", padding: "0" },
          dialogAction: { display: "none" }
        }}
      >
        <Grid width="calc(100% - 32px)" sx={{ boxSizing: "border-box", textAlign: "left" }}>
          <Grid padding="16px" sx={{ backgroundColor: tokens.Background.General.Primary }}>
            {selectedPlanDetail?.planType && location?.pathname?.split("/")[1] === "userview" && isAbovePropertyUser ? (
              <Box marginBottom={"8px"}>
                <PlanType
                  planType={selectedPlanDetail?.planType}
                  brandDeadlineDate={
                    selectedPlanDetail?.brandDeadlines && selectedPlanDetail?.brandDeadlines[0]?.deadline
                  }
                  initiativeName={selectedPlanDetail?.initiativeName}
                />
              </Box>
            ) : (
              <></>
            )}
            <PlanDetailsContent selectedPlanDetail={selectedPlanDetail} plansType={planTypes.MulipleAssign} />
          </Grid>
          <Grid marginBottom={"16px"} marginTop={"16px"}>
            <Typography component="div" variant="h4" showBold color={tokens.Text.General.PrimaryBody} textAlign="left">
              Action plan
            </Typography>
          </Grid>
          <Grid>
            {selectedPlanDetail?.sections?.length > 0 &&
              selectedPlanDetail?.sections?.map((section: any, index: number) => {
                return (
                  <Item
                    key={section.id}
                    section={section}
                    index={index}
                    planType={planTypes.MulipleAssign}
                    planId={selectedPlanDetail?.id}
                  />
                );
              })}
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
}
